import React from "react";
import {
  createStackNavigator,
  TransitionPresets,
} from "@react-navigation/stack";
import EditProfile from "./EditProfile";
import EditBasicInfo from "./Basicinfo";
import TLAddress from "@screens/Auth/TLAddress";

const Stack = createStackNavigator();

const ProfileStack = () => {
  return (
    <Stack.Navigator
      initialRouteName="EditBasicInfo"
      screenOptions={{
        headerShown: false,
        ...TransitionPresets.SlideFromRightIOS,
      }}
    >
      <Stack.Screen name="EditProfile" component={EditProfile} />
      {/* <Stack.Screen name="TLAddress" component={TLAddress} /> */}
      <Stack.Screen name="EditBasicInfo" component={EditBasicInfo} />
    </Stack.Navigator>
  );
};

export default ProfileStack;
